import React, { useState, useEffect } from "react";
import "../styles/Document.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

const Document = ({docHeader, docBody})=>{
    return(
    <>
     <div className="mx-auto md:px-8 w-full min-h-full header"> {docHeader} </div>
    <div
      className="body"
      style={{
        width: "100%",
        pointerEvents: "none",
        textAlign: "justify",
      }}
      disabled="false"
      dangerouslySetInnerHTML={{ __html: docBody }}
    ></div>
    </>
   
    )
}

export default Document;